import React, { useEffect, useState } from "react";
import { VALIDATIONS, VALIDATIONS_TEXT } from "../../../app-constants";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import TekLoader from "../../images/Tek-Spinner.gif";
import { Link } from "gatsby";

function Webform() {

  const getBaseUrl = () => {
    if (
      typeof window !== "undefined" &&
      (window.location.href.includes(
        "https://staging-tekrevol.tekstagearea.com"
      ) ||
        window.location.href.includes("http://localhost:8000") ||
        window.location.href.includes("http://localhost:9000"))
    ) {
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    } else {
      // return "https://tekrevol.tekstagearea.com/api/v1/contact-form";
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    }
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [Success, SetSuccess] = useState(false);
  const [Loading, SetLoading] = useState(false);
  const onSubmit = async (data) => {
    const url = window.location.href;
    data.form_path = url.split("?")[0];
    SetLoading(true);

    const baseUrl = getBaseUrl(); // Get the base URL
    const response = await axios.post(baseUrl, data);

    // const response = await axios.post(
    //   `https://tekrevol.tekstagearea.com/api/v1/contact-form`,
    //   data
    // );
    SetSuccess(true);
    setTimeout(() => {
      SetSuccess(false);
    }, 2000);
    SetLoading(false);
    reset({
      name: "",
      email: "",
      phone: "",
      nda: "",
      description: "",
    });
  };
  return (
    <div className="content_form web_contact_form">
      <Form
        className="content_form_inner"
        onSubmit={handleSubmit(onSubmit)}
        method="POST"
      >
        <h3>Get in Touch Now!</h3>
        <Form.Group className="from_item">
          <Form.Control
            type="text"
            placeholder="Full Name"
            name="name"
            {...register("name", {
              maxLength: {
                value: VALIDATIONS.NAME,
                message: VALIDATIONS_TEXT.NAME_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.NAME_REQUIRED,
              },
            })}
          />
          {errors.name && (
            <span className="error_tek">{errors.name?.message}</span>
          )}
        </Form.Group>
        <Form.Group className="from_item">
          <Form.Control
            type="email"
            placeholder="Email"
            name="email"
            {...register("email", {
              maxLength: {
                value: VALIDATIONS.EMAIL,
                message: VALIDATIONS_TEXT.EMAIL_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: VALIDATIONS_TEXT.EMAIL_FORMAT,
              },
            })}
          />
          {errors.email && (
            <span className="error_tek">{errors.email?.message}</span>
          )}
        </Form.Group>
        <Form.Group className="from_item">
          <Form.Control
            type="tel"
            placeholder="Number"
            name="phone"
            {...register("phone", {
              pattern: {
                value: /^\+?\d*$/,
                message: VALIDATIONS_TEXT.INVALID_PHONE_FORMAT,
              },
              minLength: {
                value: VALIDATIONS.PHONE_MIN,
                message: VALIDATIONS_TEXT.PHONE_MIN,
              },
              maxLength: {
                value: VALIDATIONS.PHONE_MAX,
                message: VALIDATIONS_TEXT.PHONE_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.PHONE_REQUIRED,
              },
            })}
          />
          {errors.phone && (
            <span className="error_tek">{errors.phone?.message}</span>
          )}
        </Form.Group>

        <Form.Group className="from_item">
          <Form.Control
            as="textarea"
            rows={4}
            name="description"
            placeholder="About Project"
            {...register("description", {
              maxLength: {
                value: VALIDATIONS.DESCRIPTION_MAX,
                message: VALIDATIONS_TEXT.DESCRIPTION_MAX,
              },
              required: {
                value: true,
                message: VALIDATIONS_TEXT.DESCRIPTION_REQUIRED,
              },
            })}
          />
          {errors.description && (
            <span className="error_tek">{errors.description?.message}</span>
          )}
          <p>
            {" "}
            <p>
              By submitting this form, you agree to our
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                {} Privacy Policy
              </a>
            </p>
          </p>
        </Form.Group>
        {!Loading ? (
          <Button variant="primary" className="btn_submit" type="submit">
            Submit
          </Button>
        ) : (
          <img
            src={TekLoader}
            alt="img_looder"
            className="img-fluid looder_img"
          />
        )}
      </Form>
      {Success ? (
        <div className="alert-success">
          Thank you for your message. It has been sent.
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Webform;
